// extracted by mini-css-extract-plugin
export default {"infoMessage":"styles_infoMessage__+Geo1"};